import React, { useState } from 'react'
import { Box, TextField, Button, Chip, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface LabelEditorProps {
  labels: Record<string, string>
  onChange: (labels: Record<string, string>) => void
  disabled?: boolean
}

const LabelEditor: React.FC<LabelEditorProps> = ({ labels, onChange, disabled }) => {
  const [newKey, setNewKey] = useState('')
  const [newValue, setNewValue] = useState('')

  const handleAdd = () => {
    if (newKey.trim() && newValue.trim()) {
      onChange({ ...labels, [newKey.trim()]: newValue.trim() })
      setNewKey('')
      setNewValue('')
    }
  }

  const handleDelete = (key: string) => {
    const { [key]: _, ...rest } = labels
    onChange(rest)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    }
  }

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>Labels</Typography>

      {/* Existing labels as chips */}
      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2, gap: 1 }}>
        {Object.entries(labels).map(([key, value]) => (
          <Chip
            key={key}
            label={`${key}: ${value}`}
            onDelete={disabled ? undefined : () => handleDelete(key)}
            disabled={disabled}
          />
        ))}
      </Stack>

      {/* Add new label */}
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <TextField
          size="small"
          label="Key"
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <TextField
          size="small"
          label="Value"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <Button
          variant="outlined"
          color="info"
          onClick={handleAdd}
          disabled={disabled || !newKey.trim() || !newValue.trim()}
          startIcon={<AddIcon />}
        >
          Add
        </Button>
      </Stack>
    </Box>
  )
}

export default LabelEditor
